import React from 'react';

const StatCard = ({ title, value, icon: Icon, color }) => {
  const colors = {
    emerald: 'bg-emerald-500/20 text-emerald-400',
    blue: 'bg-blue-500/20 text-blue-400',
    purple: 'bg-purple-500/20 text-purple-400',
    amber: 'bg-amber-500/20 text-amber-400',
  };

  return (
    <div className="bg-slate-800/50 rounded-2xl border border-slate-700 p-4 sm:p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-slate-400 text-xs sm:text-sm">{title}</p>
          <p className="text-2xl sm:text-3xl font-bold text-white mt-1">{value}</p>
        </div>
        <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center ${colors[color]}`}>
          <Icon className="w-5 h-5 sm:w-6 sm:h-6" />
        </div>
      </div>
    </div>
  );
};

export default StatCard;
